var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"has-centered-content"},[_c('div',{staticClass:"panel-container"},[_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t('Processing Login with UPS'))+".")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }